import React, { FC, useEffect, useRef } from 'react';
import {
  IViewResolverLiteProps,
  IViewResolverProviderProps,
  TRendererMap,
  ViewResolverProvider,
} from '@ldp/view-resolver-lite';
import { TViewDefinition } from '../../utils/view-resolver-utils';
import {
  useRendererCallbackMap,
  useRendererMapSSR,
  useSkeletonMap,
} from '../../hooks';

/** Don't forget to add prop types */
export interface IViewResolverSdmInnerSSRProps
  extends Omit<IViewResolverLiteProps, 'rendererMap' | 'skeletonMap' | 'rendererCbMap' | 'isFederated'> {
  children?: React.ReactNode;
  baseFont?: number;
  designTokenPlatform?: string;
  initialData?: TViewDefinition;
  enableSSR?: boolean;
}

/** Inner component which allows the hooks to access common context props */
export const ViewResolverSdmInnerSSR: FC<IViewResolverSdmInnerSSRProps> = ({
  pageId,
  locale = 'en',
  initialData,
  children,
  ...rest
}) => {
  const skeletonMap = useSkeletonMap();
  const rendererMapSSR = useRendererMapSSR();
  const rendererCbMap = useRendererCallbackMap();
  const renderMapData = rendererMapSSR;

  // Required by @ldp/view-resolver-lite WithRendererCallbacks to fire onLoad/onView (ad_load, ad_view)
  const renderersLoadedRef = useRef(new Map<string, boolean>());
  useEffect(() => {
    renderersLoadedRef.current.clear();
  }, [pageId, locale]);

  const providerProps: Omit<IViewResolverProviderProps, 'children'> = {
    pageId,
    locale,
    viewDefinition: initialData as any,
    ...rest,
    skeletonMap: skeletonMap,
    rendererMap: renderMapData as unknown as TRendererMap,
    rendererCbMap: rendererCbMap,
    fetchOptions: {},
    renderersLoadedRef,
  };

  return (
    <ViewResolverProvider {...providerProps}>
      {children}
    </ViewResolverProvider>
  );
};

export default ViewResolverSdmInnerSSR;
